import { history } from 'common/helpers/history';

// Copy text to the clipboard where the browser allows it; a no-op otherwise
// (insecure origins and old browsers have no navigator.clipboard).
export const copyToClipboard = (text) => {
  if (typeof navigator === 'undefined' || !navigator.clipboard || !navigator.clipboard.writeText) {
    return Promise.resolve(false);
  }
  return navigator.clipboard.writeText(text).then(() => true, () => false);
};

export const shortReference = eventId => (eventId ? eventId.slice(0, 8) : '');

export const reloadPage = () => window.location.reload();

// A deep link (new tab, alert email) has nothing to go back to inside the app,
// so it goes home instead of leaving the app or doing nothing.
export const goBack = () => {
  if (window.history.length > 1) {
    history.goBack();
  } else {
    history.push('/');
  }
};
